export default "__VITE_ASSET__C1ucnCW2__"